<div *ngIf="notificaciones==null" class="w-100 mt-3">
<mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<div *ngIf="notificaciones!=null" class="listado-page">
    <div class="listado__stats">
        <div class="listado__stat">
            <div class="listado__stat-value">{{ totalNotificaciones }}</div>
            <div class="listado__stat-label">{{ 'COMMON.LIST.TOTAL' | translate }}</div>
        </div>
        <div class="listado__stat">
            <div class="listado__stat-value is-muted">{{ notificacionesMostradas }}</div>
            <div class="listado__stat-label">{{ 'COMMON.LIST.SHOWING' | translate }}</div>
        </div>
    </div>

    <div class="listado-table-wrapper listado listado--cards-accent">
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z0">

            <ng-container matColumnDef="Identificador">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'NOTIFICATION.DETAIL.IDENTIFIER' | translate }}</th>
                <td mat-cell *matCellDef="let object" [attr.data-label]="'NOTIFICATION.DETAIL.IDENTIFIER' | translate" data-role="title">
                    {{ object['Identificador'] }}
                </td>
            </ng-container>

            <ng-container matColumnDef="Fecha disposición">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'NOTIFICATION.DETAIL.DATE' | translate }}</th>
                <td mat-cell *matCellDef="let object" [attr.data-label]="'NOTIFICATION.DETAIL.DATE' | translate" data-role="meta">
                    {{ object['Fecha disposición'] ? formatDate(object['Fecha disposición']) : '' }}
                </td>
            </ng-container>

            <ng-container matColumnDef="Fecha rechazo automático">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'NOTIFICATION.DETAIL.AUTO_REJECT_DATE' | translate }}</th>
                <td mat-cell *matCellDef="let object" [attr.data-label]="'NOTIFICATION.DETAIL.AUTO_REJECT_DATE' | translate">
                    {{ object['Fecha rechazo automático'] ? formatDate(object['Fecha rechazo automático']) : '' }}
                </td>
            </ng-container>

            <ng-container matColumnDef="Entidad">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'NOTIFICATION.DETAIL.ISSUER' | translate }}</th>
                <td mat-cell *matCellDef="let object" [attr.data-label]="'NOTIFICATION.DETAIL.ISSUER' | translate">
                    {{ object['Entidad'] }}
                </td>
            </ng-container>

            <ng-container matColumnDef="Tipo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'NOTIFICATION.DETAIL.TYPE' | translate }}</th>
                <td mat-cell *matCellDef="let object" [attr.data-label]="'NOTIFICATION.DETAIL.TYPE' | translate">
                    {{ object['Tipo'] }}
                </td>
            </ng-container>

            <ng-container matColumnDef="Tipo receptor">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'NOTIFICATION.DETAIL.RECEIVER_TYPE' | translate }}</th>
                <td mat-cell *matCellDef="let object" [attr.data-label]="'NOTIFICATION.DETAIL.RECEIVER_TYPE' | translate">
                    {{ object['Tipo receptor'] }}
                </td>
            </ng-container>

            <ng-container matColumnDef="Descripción">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'NOTIFICATION.DETAIL.DESCRIPTION' | translate }}</th>
                <td mat-cell *matCellDef="let object" [attr.data-label]="'NOTIFICATION.DETAIL.DESCRIPTION' | translate">
                    {{ object['Descripción'] }}
                </td>
            </ng-container>

            <ng-container matColumnDef="acciones">
                <th mat-header-cell *matHeaderCellDef class="em-th-actions">{{ 'TRAMITE_LIST.COLUMN.ACTIONS' | translate }}</th>
                <td mat-cell *matCellDef="let object" class="em-td-actions" data-role="actions" [attr.data-label]="'TRAMITE_LIST.COLUMN.ACTIONS' | translate">
                    <div class="em-actions-wrap">
                        <button type="button" class="em-icon-btn"
                            [disabled]="loading"
                            [matTooltip]="'NOTIFICATION.BUTTON.ACCEPT' | translate"
                            matTooltipClass="em-tooltip"
                            matTooltipPosition="left"
                            (click)="acceptButton(object['Destinatario'])">
                            <mat-icon>check_circle</mat-icon>
                        </button>
                        <button type="button" class="em-icon-btn em-icon-btn--danger"
                            [disabled]="loading"
                            [matTooltip]="'NOTIFICATION.BUTTON.REJECT' | translate"
                            matTooltipClass="em-tooltip"
                            matTooltipPosition="left"
                            (click)="rechazoButton(object['Destinatario'])">
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns.concat(['acciones'])"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns.concat(['acciones']);"></tr>
        </table>
    </div>

    <mat-paginator [pageSizeOptions]="[5, 10, 25]" [pageSize]="5" showFirstLastButtons></mat-paginator>

    <div class="w-100 mt-3 alertPuestosNot">
        <img src="assets/triangle-exclamation.svg" class="iconAlertNot"/>{{ 'NOTIFICATION.AUTO_REJECT_WARNING' | translate }} {{diasCaducidad}} {{ 'TRAMITE.CONTENT.DIAS_DE_ANTIGUEDAD' | translate }}
    </div>
    <ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-clip-rotate" [fullScreen] = "true" [name]="'notificaciones_usuario_spinner'">
        <p style="color: white" >{{mensajeSpinner}}</p>
      </ngx-spinner>
    <form id="firma" (submit)="resultchange($event)" class="">
        <input type="hidden" id="result" />
        <input type="hidden" id="error" />
        <input type="hidden" id="certifcado" />
    </form>
</div>
<form (ngSubmit)="notificacionAcept()">
    <div class="gu-confirm-overlay" *ngIf="displayFirma === 'block'">
        <div class="gu-confirm" role="dialog" aria-modal="true">
            <div class="gu-confirm__icon">
                <mat-icon>warning</mat-icon>
            </div>
            <h3 class="gu-confirm__title">
                {{ (notificacionActivada?.aceptar ? 'NOTIFICATION.CONFIRM.ACCEPT_TITLE' : 'NOTIFICATION.CONFIRM.REJECT_TITLE') | translate }}
            </h3>
            <p class="gu-confirm__message">
                {{ (notificacionActivada?.aceptar ? 'NOTIFICATION.CONFIRM.ACCEPT' : 'NOTIFICATION.CONFIRM.REJECT') | translate }}
            </p>
            <div class="gu-confirm__actions">
                <button type="button" class="gu-btn gu-btn--ghost" (click)="closeButton()">
                    {{ 'NOTIFICATION.BUTTON.CANCEL' | translate }}
                </button>
                <fieldset class="gu-confirm__firma" [class.gu-confirm__firma--danger]="!notificacionActivada?.aceptar">
                    <boton-listado></boton-listado>
                </fieldset>
            </div>
        </div>
    </div>
</form>
